import { SelectLangController } from "./select-lang.controller";

angular
    .module("thor.shared.select-lang.component", [])
    .component("selectLang", {
        bindings: {
            currentLang: "=?"
        },
        controller: SelectLangController,
        template: require("./select-lang.html")
    });
